module.exports = __webpack_public_path__ + "media/images/icons/active-doctors-44e8e6649431abfffda47efc804a874f.svg";